import { ProfileSlice } from 'store/pages/profile/slice'

import { fetchTransactions } from './fetchTransactions'

export const ProfileActions = {
  ...ProfileSlice.actions,
  fetchTransactions,
}
